// NFLDemoContext — provides demo mode flag and write guard
// File recreated after git history cleanup loss

import { createContext, useContext } from 'react';

interface NFLDemoContextValue {
  isDemoMode: boolean;
  guardWrite: () => boolean;
}

const NFLDemoCtx = createContext<NFLDemoContextValue | null>(null);

export function useNFLDemoOptional(): NFLDemoContextValue | null {
  return useContext(NFLDemoCtx);
}

export default NFLDemoCtx;
